import { AuditWrapper } from '../../../components/hub/AuditWrapper';
import { AppsPage } from '../../AppsPage';

export function HubAppsPage() {
  return (
    <AuditWrapper>
      <AppsPage />
    </AuditWrapper>
  );
}
